export const roles = [
  "Administration",
  "Advisor",
  "Application Engineer",
  "Architect",
  "Art Director/Designer",
  "Assistant",
  "Builder",
  "Building Owner",
  "Business Development Manager",
  "Business Owner",
  "Buyer",
  "Carpenter/Shopfitter",
  "CEO/President",
  "Chairman",
  "Coater",
  "Commercial (Sales/Marketing)",
  "Company Mailing Address",
  "Consultant",
  "Consumer",
  "Contractor",
  "Controller",
  "Custom App",
  "Customer Support Representative",
  "Dealer",
  "Design Engineer",
  "Designer",
  "Distributor",
  "Director",
  "Doctor",
  "Engineer",
  "Executive",
  "Fabricator",
  "Facade Builder",
  "Facility Manager",
  "Finance",
  "General Contractor",
  "HSE (Health, Safety & Environment)",
  "Influencer",
  "Information Technology",
  "Interior Architect",
  "Kitchen / Bathroom Specialist",
  "Lab Manager",
  "Lead Contact",
  "Logistics",
  "Management",
  "Manufacturing",
  "Marketing",
  "Material Engineer",
  "Media",
  "Office",
  "Operations",
  "Order fulfillment",
  "Other",
  "Owner",
  "Plant Manager",
  "Plumber",
  "Printer",
  "Procurement",
  "Product Development",
  "Production Manager",
  "Project Manager",
  "Purchasing",
  "Quality",
  "Quality Assurance",
  "R&D",
  "REACH Coordinator",
  "Real Estate Developer",
  "Regulatory",
  "Research and development",
  "Retailer",
  "Roofer",
  "Sales",
  "Sales & Marketing",
  "Student/Professor",
  "Supply Chain/Logistics",
  "Technical",
  "Technology Leader",
  "Training",
  "Vice President",
  "Warehouse",
  "Manufacturing/Utility",
  "Human Resource",
  "Admin"
];
